import { Eye, Edit, Copy, Trash2 } from "lucide-react";
import type { ActionItem } from "@/components/ui/actions-dropdown";
import type { ActionSurface } from "./types";

export interface PppcPolicyActionsContext {
  surface: ActionSurface;
  onView: () => void;
  onEdit: () => void;
  onDuplicate: () => void;
  onDelete: () => void;
}

const L = (s: ActionSurface, list: string, detail: string) =>
  s === "list" ? list : detail;

export function buildPppcPolicyActions(ctx: PppcPolicyActionsContext): ActionItem[] {
  const { surface } = ctx;
  const items: ActionItem[] = [];
  if (surface === "list") {
    items.push({ label: "View", icon: Eye, onClick: ctx.onView });
  }
  items.push(
    { label: L(surface, "Edit", "Edit PPPC Policy"), icon: Edit, onClick: ctx.onEdit },
    { label: L(surface, "Duplicate", "Duplicate PPPC Policy"), icon: Copy, onClick: ctx.onDuplicate },
    { label: L(surface, "Delete", "Delete PPPC Policy"), icon: Trash2, onClick: ctx.onDelete, destructive: true },
  );
  return items;
}
